import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// =============================================================================
//  Copyright : 2018 semantics GmbH
//  Date      : $Date: 2026-01-31 22:57:43 +0100 (Sat, 31 Jan 2026) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 160223 $
//  Purpose   : example part
/*
<!-- adding a new view (/uix/theview/123) to server/config/templateconfig.xml -->
<class name="uix" acl="g:admin">
  <tab name="theview" cfg="templating.feature.on">
      <part type="ExamplePart" acl="g:admin" style="flex:1" >
        <filter type="getExampleData"/>
      </part>
  </tab>
*/ // =============================================================================
// ---Third-party imports
import React from 'react';
import { Segment, Grid, Icon } from 'semantic-ui-react';
// ---Framework imports
import { Actions, Sel } from 'uix/registries';
import { funcPart } from 'uix/parts';
import log from 'uix/logging';
import { keys } from 'ldash';
import { useSelector, useState, useActions } from 'uix/hooks';
// ---Local imports
import { sendSignal } from './actions';
// ---Exports
// functional components can give an (optional) part specification dict with Part config
const spec = {
    storeMap: 'config.ddata'
};
export const FunctionalPart = funcPart(spec, ({ dname, ddata, ...props })=>{
    let dconfig = useSelector(Sel.dconfig);
    let [clicked, setClicked] = useState(false);
    log.warn('rendering the functional example %o', props);
    log.info('request domain is a default part prop: %o', dname);
    log.info('store access via redux connect HOC: %o', ddata);
    log.info('store access via redux selector hook: %o', dconfig);
    return /*#__PURE__*/ _jsxs(Segment, {
        onClick: ()=>setClicked(true),
        children: [
            "Welcome to ",
            keys(props.domains.data).join(', '),
            /*#__PURE__*/ _jsx("br", {}),
            "clicked: ",
            String(clicked)
        ]
    });
});
export const ExamplePart = funcPart({
    getGraphics: [
        'types'
    ],
    partStyle: {
        display: 'flex',
        flexDirection: 'column',
        height: '95%'
    }
}, (props)=>{
    let [go] = useActions([
        Actions.go
    ]);
    log.warn('rendering the example %o', props);
    vl.pprint(props);
    return /*#__PURE__*/ _jsx("div", {
        onClick: ()=>sendSignal({
                hello: 'world'
            }),
        children: "hello world"
    });
});
